export default __webpack_public_path__ + "static/media/icon-card-general-settings.d9576ea2.svg";